import { render, staticRenderFns } from "./hongqi.vue?vue&type=template&id=3fc6054a&scoped=true"
import script from "./hongqi.vue?vue&type=script&lang=js"
export * from "./hongqi.vue?vue&type=script&lang=js"
import style0 from "./hongqi.vue?vue&type=style&index=0&id=3fc6054a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc6054a",
  null
  
)

export default component.exports